import { TypeStructure } from 'types/Concessionnaire';

export default {
  translation: {
    locale: 'fr-FR',
    'shared.french': 'Français',
    'app.name': 'Espace Partenaire Hellio',
    'auth.hero': 'Bienvenue sur votre\nEspace Partenaire',
  },
  global: {
    password: 'Mot de passe',
    email: 'E-mail',
    logout: 'Déconnexion',
    cancel: 'Annuler',
    close: 'Fermer',
    required: 'Ce champ est obligatoire',
    internet_connexion_error:
      'Une erreur inattendue s’est produite. Veuillez réessayer plus tard.',
    'email.required': 'Veuillez renseigner une adresse e-mail valide',
    session_expired: 'Votre session a expiré. Veuillez vous reconnecter.',
    label: '{{label}} :',
    previous: 'Précédent',
    next: 'Suivant',
    quitter: 'Quitter',
    continuer: 'Continuer',
    soumettre_mon_dossier: 'Soumettre mon dossier',
    enregistrer_et_continuer: 'Enregistrer et continuer',
    yes: 'Oui',
    no: 'Non',
    date: 'Date',
    select_date: 'Sélectionnez une date',
    mr: 'Monsieur',
    mrs: 'Madame',
    validate: 'Valider',
    phone: 'Téléphone',
    number_not_allowed: 'Les nombres ne sont pas autorisés',
    email_invalid: 'Veuillez saisir un format mail valide',
    phone_invalid:
      'Veuillez saisir un numéro de téléphone valide à 10 chiffres, sans espaces ni caractères spéciaux (ex : 0612345678).',
    postal_code_invalid: 'Veuillez saisir un format code postal valide',
    export_date: 'Date d’export : {{date}}',
    number_invalid: 'Veuillez saisir un nombre.',
    integer_invalid: 'Veuillez saisir un nombre entier.',
    enter_number: 'Saisissez un nombre…',
    enter_integer: 'Saisissez un nombre entier…',
    enter_number_interval: 'Saisissez un nombre entre {{min}} et {{max}}…',
    enter_integer_interval:
      'Saisissez un nombre entier entre {{min}} et {{max}}…',
    no_data: 'Aucune donnée disponible',
    no_siret: 'Je ne trouve pas le numéro siret',
    no_address: 'Je ne trouve pas l’adresse',
    errors: {
      siret_14_caracteres: 'Le SIRET doit contenir 14 caractères.',
      siret_chiffres: 'Le SIRET doit contenir uniquement des chiffres.',
    },
    champs_requis: 'Les champs signalés par un astérisque * sont obligatoires.',
    back_home: "Revenir à l'accueil",
    account_logo_alt: 'Logo partenaire',
    copier_email: "Copier l'adresse e-mail",
    email_copie: 'E-mail copié dans le presse-papier',
    erreur_copie: "Erreur lors de la copie de l'e-mail",
    info_button: {
      aria_label: 'Afficher les informations',
      title: 'Cliquez pour afficher les informations',
    },
    vue_tableau: 'Vue Tableau',
    vue_graphique: 'Vue Graphique',
    vue_statut: 'Vue Statut',
    actions: 'Actions',
    view: 'Voir',
    download: 'Télécharger',
    vehicule: '{{count}} véhicules',
    vehicule_one: '{{count}} véhicule',
    soumettre_un_dossier: 'Soumettre un dossier',
    calculer_ma_prime: 'Calculer une prime',
    select_option: 'Sélectionnez une option',
  },
  unknown_file: '',
  filesize: {
    zero: '0 octets',
    symbols: {
      iec: {
        bytes: {
          B: 'o',
          KiB: 'Kio',
          MiB: 'Mio',
          GiB: 'Gio',
          TiB: 'Tio',
          PiB: 'Pio',
          EiB: 'Eio',
          ZiB: 'Zio',
          YiB: 'Yio',
        },
      },
      jedec: {
        bytes: {
          B: 'o',
          KB: 'Ko',
          MB: 'Mo',
          GB: 'Go',
          TB: 'To',
          PB: 'Po',
          EB: 'Eo',
          ZB: 'Zo',
          YB: 'Yo',
        },
      },
    },
  },
  statuts_dossier: {
    EtudeEnCours: 'Étude en cours',
    OffreEmise: 'Offre émise',
    OffreAcceptee: 'Offre acceptée',
    ChantierEnCours: 'Chantier en cours',
    ChantierEnCours_concession: 'Dossier en cours',
    DocumentsEnAttente: 'Documents en attente',
    Recu: 'Reçu',
    EnAttenteDeControle: 'En attente de contrôle',
    Incomplet: 'Incomplet',
    Valide: 'Validé',
    PrimeProPayee: 'Prime Pro payée',
    PrimeBeneficiairePayee: 'Prime Bénéficiaire payée',
    PrimeGlobalePayee: 'Prime Globale Payée',
    Refuse: 'Refusé',
    Abandon: 'Abandon',
    DemandeInformations: 'Demande d’informations',
    EnCoursDeValidation: 'En cours de validation',
    Termine: 'Terminé',
    PrimeVersee: 'Prime versée',
    InformationsComplementairesRequises:
      'Informations complémentaires requises',
  },
  statuts_operation: {
    Eligible: 'Éligible',
    AConfirmer: 'Éligibilité à confirmer',
    NonConfirme: 'Eligibilité non-confirmée à ce stade',
    Recommandations: 'Recommandations',
    Annule: 'Annulé',
    DossierEnCoursDeValidation: 'Dossier en cours de validation',
    Incomplet: 'Incomplet',
    RemisAuControle: 'Remis au contrôle',
    PreValide: 'Pré-validé',
    BonPourPrime: 'Bon pour prime',
    NonConforme: 'Non-conforme (Qualité)',
    ActionEnCours: 'Actions en cours',
    Litige: 'Litige',
    Refuse: 'Refusé',
  },
  login: {
    hero: 'Connexion',
    description: 'Renseignez votre adresse email et votre mot de passe',
    forgot: 'Mot de passe oublié ?',
    login_error:
      'Vos identifiants de connexion sont incorrects, veuillez vérifier votre saisie.',
    submit: 'Se connecter',
    token_error: 'Votre lien à expiré ou n’est plus valide',
    impersonate: 'Connecté en tant que {{name}}',
  },
  auth_footer: {
    mentions: 'Mentions légales',
    conditions: 'Conditions Générales d’Utilisation',
    politique: 'Politique de confidentialité',
  },
  first_login: {
    hero: 'Première connexion',
    description: 'Renseignez votre mot de passe',
    success: 'Création de votre mot de passe',
    error: 'Votre lien à expiré ou n’est plus valide',
    success_description: 'Votre mot de passe a bien été pris en compte.',
    success_action: 'Se connecter',
    submit: 'Valider',
    same: 'Les mots de passes ne sont pas identiques',
    'confirm.password': 'Confirmer mot de passe',
    'confirm.regex.error':
      'Le mot de passe doit contenir au moins 8 caractères, dont une majuscule, un chiffre et un caractère spécial.',
    'confirm.placeholder.password': 'Confirmer le mot de passe',
    expired: {
      title: 'Lien de connexion expiré',
      alert: {
        title: 'Votre lien de connexion a expiré',
        text: 'Votre lien de connexion a expiré. Pour des raisons de sécurité, les liens de connexion sont valables uniquement pendant une durée limitée.',
      },
      cta: 'Recevoir un nouveau lien',
    },
    email_sent: {
      title: 'E-mail envoyé',
      alert: {
        title: 'Votre lien de connexion a été envoyé par mail',
        text: 'Vous n’avez pas reçu cet e-mail ?<br/>Vérifiez vos courriers indésirables ou contactez votre référent Hellio',
      },
    },
  },
  change_password: {
    hero: 'Réinitialisation de mot de passe',
    description: 'Renseignez votre nouveau mot de passe',
    password: 'Nouveau mot de passe',
    'password.placeholder': 'Saisir le nouveau mot de passe',
    submit: 'Valider',
    success: 'Modification du mot de passe',
    success_message: 'Votre mot de passe a bien été réinitialisé',
    success_action: 'Se connecter',
    same: 'Les mots de passes ne sont pas identiques',
    'confirm.password': 'Confirmer le nouveau mot de passe',
    'confirm.regex.error':
      'Le mot de passe doit contenir au moins 8 caractères, dont une majuscule, un chiffre et un caractère spécial.',
    'confirm.placeholder.password': 'Confirmer le nouveau mot de passe',
  },
  error: {
    hero: 'Une erreur est survenue',
    description: 'Une erreur est survenue.\nEssayez d’actualiser la page.',
    action: 'Actualiser',
  },
  404: {
    hero: 'Page introuvable',
    description: 'La page que vous cherchez n’existe pas ou a été déplacée.',
    back: 'Retour à l’accueil',
  },
  not_implemented: {
    hero: 'Non implémenté',
  },
  reset_password: {
    hero: 'Mot de passe oublié',
    description:
      'Veuillez saisir votre adresse e-mail afin de recevoir le lien de réinitialisation de votre mot de passe',
    submit: 'Valider',
    error: 'Votre lien à expiré ou n’est plus valide',
    back: 'Retour',
    back_to_login: 'Se connecter',
    email_sent: {
      alert: {
        title: 'Réinitialisation de mot de passe',
        description:
          'Nous vous avons envoyé un e-mail pour réinitialiser votre mot de passe. Pour créer votre nouveau mot de passe, il vous suffit de cliquer sur le lien contenu dans l’e-mail et d’en saisir un nouveau.',
      },
      support:
        '<strong>Vous n’avez pas reçu cet e-mail ?</strong><br/>Vérifiez vos courriers indésirables ou contactez votre référent Hellio',
    },
  },
  homepage: {
    hero: 'Accueil',
  },
  nouveau_formulaire: {
    hero: 'Soumission d’un dossier',
    etapes: {
      etape_1: 'Informations client',
      etape_2: 'Informations commande',
      etape_3: 'Informations prime',
    },
    type_client: {
      label: 'Type de client final',
    },
    vehicule_type: {
      placeholder: 'Sélectionnez la catégorie du ou des véhicules',
      label: 'Catégorie du ou des véhicules',
    },
    status_precarite: {
      label: 'Statut de precarité',
      info_label: 'Détail sur le statut de précarité',
      hint: 'Pour définir la précarité de votre client, aidez-vous du tableau ci dessous',
    },
    siret: {
      label: 'SIRET',
      placeholder: 'Ex : 47937499202104',
    },
    raison_sociale: {
      label: 'Raison sociale',
      placeholder: 'Ex : Ikea',
    },
    etablissement: {
      label: "Désignation de l'établissement utilisant le(s) véhicule(s)",
      placeholder: 'Ex : Hellio Clichy',
    },
    marque_vehicule: {
      label: 'Marque du ou des véhicule(s) commandé(s)',
      placeholder: 'Sélectionnez la marque du ou des véhicule(s)',
    },
    adresse: {
      label: 'Adresse de l’établissement',
      label_short: 'Adresse postale',
      placeholder: 'Ex : 50 rue madame de Sanzillon',
    },
    code_postal: {
      label: 'Code postal de l’établissement',
      label_short: 'Code postal',
      placeholder: 'Ex : 92110',
      error: 'Le code postal doit contenir 5 chiffres.',
      unknown:
        'Le code postal saisi n’est pas reconnu. Veuillez vérifier qu’il correspond bien à une commune française.',
    },
    ville: {
      label: 'Ville de l’établissement',
      label_short: 'Ville',
      placeholder: 'Ex : Clichy sous bois',
    },
    coordonnees: 'Coordonnées du client',
    etablissement_section_title: "Informations de l'établissement",
    bon_commande_section_title: 'Bon de commande',
    questions_achat_vehicules_neufs_section_title:
      'Questions relatives à l’achat d’un ou plusieurs véhicules légers électriques neufs',
    lastname: {
      label: 'Nom',
      placeholder: 'Ex : Jean',
    },
    firstname: {
      label: 'Prénom',
      placeholder: 'Ex : Marc',
    },
    phone: {
      label: 'Téléphone',
      placeholder: 'Ex : 0612345678',
    },
    email: {
      label: 'Email',
      placeholder: 'Ex : jeanmarc@gmail.com',
    },
    fonction: {
      label: 'Fonction',
      placeholder: 'Président Directeur Général',
    },
    typeStructure: {
      label: 'Type de structure',
      placeholder: 'Sélectionnez le type de structure',
      emptyOption: 'Non renseigné',
      options: {
        [TypeStructure.Association]: 'Association',
        [TypeStructure.BailleurSocial]: 'Bailleur social',
        [TypeStructure.CollectiviteTerritoriale]: 'Collectivité territoriale',
        [TypeStructure.PromoteurPrive]: 'Promoteur privé',
        [TypeStructure.SyndicDeCopropriete]: 'Syndic de copropriété',
        [TypeStructure.SCI]: 'SCI',
        [TypeStructure.EntreprisePrivee]: 'Entreprise privée',
        [TypeStructure.Autre]: 'Autre',
      },
    },
    typeAcheteur: {
      label: 'Type de client',
      placeholder: 'Sélectionnez le type de client',
      options: {
        company_less_100:
          'Personne morale autre qu’une collectivité territoriale avec un parc roulant inférieur à 100 véhicules',
        company_more_100:
          'Personne morale autre qu’une collectivité territoriale avec un parc roulant supérieur à 100 véhicules',
        org_less_20:
          'Collectivité avec un parc roulant inférieur à 20 véhicules',
        org_more_20:
          'Collectivité avec un parc roulant supérieur à 20 véhicules',
        loueur_ou_vendeur: 'Loueur ou vendeur de véhicules',
        agglo_less_250: 'Agglomération ≤ 250 000 habitants',
        agglo_more_250: 'Agglomération > 250 000 habitants',
        other: 'Autre personne morale',
      },
    },
    isVehiculeDemonstration: {
      label: 'Le véhicule est un véhicule de démonstration',
      options: {
        oui: 'Oui',
        non: 'Non',
      },
    },
    modeVersement: {
      label: 'Mode de versement de la prime',
      remise_devis: 'Remise sur devis (3.1)',
      hellio: 'Versement par Hellio à l’acheteur (3.2)',
    },
    nbDevis: {
      label: 'N° du bon de commande',
      placeholder: 'Ex : BDC-793738',
      tip: 'Merci de saisir la référence exacte de votre Bon de Commande',
    },
    devis: {
      label: 'Bon de commande',
      hint: 'Glissez le bon de commande ou {{action}}cliquez ici pour le charger',
      required: 'Ce document est obligatoire',
    },
    other_files: {
      label: 'Autres documents',
      info: 'Pour les véhicules précédemment affectés à la démonstration, le premier certificat d’immatriculation ainsi que le second, et le récépissé de fin de démonstration doivent être fournis.',
      hint: 'Glissez les documents ou {{action}}cliquez ici pour les charger',
    },
    avis_imposition: {
      label: 'Avis d’imposition',
      hint: 'Glissez l’avis d’imposition ou {{action}}cliquez ici pour le charger',
    },
    date_devis: {
      label: 'Date de signature du bon de commande',
      placeholder: 'Sélectionnez une date',
      after_rai:
        'La date de signature du bon de commande ne doit pas être inférieure à la date d’envoi de l’e-mail horodaté RAI ({{dateDuRAI}}).',
      banner:
        'La date de signature de votre bon de commande doit dater de moins de 30 jours.',
      error:
        'La date de signature de votre bon de commande doit dater de moins de 30 jours.',
      '3.2_error':
        'La date de signature de votre bon de commande doit être celle d’aujourd’hui.',
    },
    date_edition_devis: {
      label: 'Date d’édition du Bon de Commande',
      placeholder: 'Sélectionnez une date',
      error:
        'La date d’édition du bon de commande doit être antérieure ou égale à aujourd’hui',
      '3.2_error':
        'La date d’édition de votre bon de commande doit être celle d’aujourd’hui.',
    },
    date_previsionnelle_devis: {
      label: 'Date prévisionnelle de signature du Bon de Commande',
      placeholder: 'Sélectionnez une date',
      error:
        'Le bon de commande ne peut être signé avant la soumission de ce formulaire.',
      error_before_edition:
        "La date de signature doit être antérieure ou égale à la date d'édition du bon de commande",
    },
    date_edition: {
      label: 'Date d’édition du Bon de Commande',
      placeholder: 'Sélectionnez une date',
      banner:
        'La date de signature de votre bon de commande doit dater de moins de 30 jours.',
      error:
        'La date de signature de votre bon de commande doit dater de moins de 30 jours.',
      '3.2_error':
        'La date de signature de votre bon de commande doit être celle d’aujourd’hui.',
    },
    nb_vehicules: {
      label: 'Nombre de véhicule(s) commandé(s)',
      placeholder: '84',
      info: '<strong>Pour les entreprises</strong>, la taille de la flotte à prendre en compte est celle du groupe, intégrant tout type de véhicule dont le poids total autorisé en charge est &lt; 3,5 tonnes (équivalent M1 ou N1) : location longue durée, leasing, propriété&hellip;<br /><br /><strong>Pour les collectivités</strong>, la taille de la flotte à prendre en compte intègre tout type de véhicule dont le poids total autorisé en charge est &lt; 3,5 tonnes (équivalent M1 ou N1) : location longue durée, leasing, propriété&hellip;',
      error: 'Le nombre de véhicules commandés ne peut être égal à 0.',
    },
    date_livraison: {
      label: 'Date approximative de livraison des véhicules',
      label_single: 'Date approximative de livraison du véhicule',
      placeholder: 'Sélectionnez une date',
      tip: 'La date indiquée correspond à la livraison du premier véhicule.',
    },
    usage_vehicules: {
      label: 'Usage des véhicules',
      label_single: 'Usage du véhicule',
      placeholder: 'Sélectionnez l’usage des véhicules',
      options: {
        fonction: 'Véhicules de fonction',
        location_courte: 'Mise en location courte durée (< 2 ans)',
        location_longue: 'Mise en location longue durée (> 2 ans)',
      },
      error_courte_duree:
        'Les véhicules destinés à la location de courte durée ne sont pas éligibles à une prime CEE.',
    },
    categorie_vehicule: {
      label: 'Catégorie du véhicule',
      placeholder: 'Sélectionnez la catégorie du ou des véhicules commandés',
      options: {
        M1: 'M1',
        N1: 'N1',
        N2: 'N2 sous dérogation de poids',
      },
      bus_tip: `Un autocar ou autobus électrique neuf est considéré de grande capacité s'il est équipé d'un pantographe ou s'il satisfait le critère de capacité de batterie suivant :
        <ul><li>Pour un véhicule de 12 à 16 mètres inclus, sa capacité de batterie est ≥ 390 kWh</li><li>Pour un véhicule de 16 à 24 mètres inclus, sa capacité de batterie est ≥ 540 kWh</li><li>Pour un véhicule de plus de 24 mètres sa capacité de batterie est ≥ 690 kWh</li></ul>`,
    },
    is_beneficiaire_signataire: {
      label:
        'Le bénéficiaire indiqué sera-t-il le signataire de l’Attestation sur l’Honneur de livraison des véhicules ?',
      options: {
        oui: 'Oui',
        non: 'Non, le signataire sera une autre personne',
      },
    },
    scoreEnvironnementalAtteint: {
      label:
        'Le véhicule atteint-il un score environnemental supérieur au score minimal requis de 60 points ?',
    },
    coutAcquisitionInferieur47000: {
      label:
        'Le coût d’acquisition ou de location du véhicule incluant la batterie est-il inférieur ou égal à 47 000 € TTC ?',
    },
    masseVehiculeInferieure2400: {
      label:
        'La masse du véhicule en ordre de marche est-elle inférieure à 2400 kg ?',
    },
    dejaBeneficieBonusEcologique: {
      label:
        "Le client final n’a jamais bénéficié d'un bonus écologique et/ou d'autres incitations mises en place dans le cadre des certificats d'économies d'énergies (notamment Programme CEE PRO-INNO-85 \"Location sociale de véhicules électriques\")",
    },
    produitEnEurope: {
      label:
        'Le site de fabrication du véhicule et le site de production de la batterie du véhicule sont localisés au sein de l’Espace Économique Européen ?',
    },
    vehiculeAdeme: {
      label: 'Le véhicule figure dans une liste publiée par l’ADEME',
    },
    success: {
      isPersonnePhysique: {
        title: 'Soumission d’un dossier',
        text: 'Votre demande a bien été prise en compte.',
      },
      '3.2': {
        title: 'Prochaines étapes',
        confirmation: 'Votre demande de prime a bien été transmise.',
        next_steps: 'Voici les prochaines étapes :',
        steps: {
          item_1:
            'Votre client vient de recevoir un email contenant les informations remplies dans ce formulaire.',
          item_2:
            "Pour pouvoir passer à l'étape suivante, il devra y consulter le document <0>Rôle Actif et Incitatif (RAI)</0> via DocuSign.",
          item_3:
            'Vous recevrez alors directement un email confirmant que le document a bien été examiné.',
          item_4: 'Le client pourra alors signer le bon de commande.',
        },
      },
      '3.1': {
        title: 'Votre demande de prime a bien été transmise',
        text: 'L’acquéreur et vous, allez recevoir un mail contenant les informations remplies précédemment dans le formulaire.\nPensez à bien conserver cet email.',
      },
    },
    errors: {
      no_RAI:
        'Le RAI n’est pas configuré dans votre contrat. Veuillez contacter votre référent Hellio.',
      unknown:
        'Une erreur vous empêche de soumettre votre demande. Merci de contacter votre référent Hellio.',
    },
    resultat: {
      calcul_de_la_prime: 'Calcul de la prime',
      par_vehicule: 'Par véhicule',
      total: 'Total',
      montant_de_la_prime_description:
        'Le montant de prime indiqué ici est conditionné au respect des critères d’éligibilité CEE pour chaque véhicule.',
      nombre_vehicules: 'Nombre de véhicules',
      chaque_vehicule: 'Pour chaque véhicule :',
      categorie: 'Catégorie',
      categorie_vehicule: 'Catégorie de véhicule',
      volume_de_CEE: 'Volume de CEE',
      prime_cee: 'Prime CEE',
      prime_globale: 'Prime globale',
      prime_beneficiaire: 'Prime Bénéficiaire',
      prime_concessionnaire: 'Prime Concessionnaire',
      repartition_concessionnaire_beneficiaire:
        'Répartition entre le Concessionnaire et le Bénéficiaire',
      montant_min_prime:
        'Le montant maximum de la Prime Concessionnaire par véhicule ne peut pas dépasser 20%',
    },
  },
  ajout_dossier: {
    hero: 'Soumission de dossier',
    success: {
      title: 'Votre projet a bien été transmis',
      text: 'Un mail va vous être envoyé pour confirmer la soumission. Notre équipe reviendra vers vous prochainement, après analyse de votre dossier.',
    },
    minimized_entry: 'Une soumission de dossier en cours',
    close_confirm: {
      title: 'Êtes-vous sure de vouloir quitter la soumission de dossier ?',
      text: 'Vous êtes sur le point de quitter la soumission de dossier et allez donc perdre les informations saisies auparavant.',
      cancel_cta: 'Non, je reviens à la saisie',
      confirm_cta: 'Oui, je ferme la soumission',
    },
    home: 'Accueil',
    error: 'Erreur de soumission du dossier',
    error_reason: 'Votre dossier n’a pas pu être envoyé :',
    etapes: {
      etape_1: 'Informations sur le chantier',
      etape_1_short: 'Informations chantier',
      etape_2: 'Informations sur le bâtiment',
      etape_2_short: 'Informations site',
      etape_3: 'Contacts et Documents',
      etape_3_short: 'Contacts et Documents',
    },
  },
  add_dossier_site: {
    coordonnees_interlocuteur:
      "Coordonnées de l'interlocuteur pour le suivi du dossier",
    adresse_et_dates: 'Adresse du chantier et dates prévisionnelles',
    nom: 'Nom',
    prenom: 'Prénom',
    email: 'Email',
    nom_placeholder: 'Ex : Jean',
    prenom_placeholder: 'Ex : Marc',
    email_placeholder: 'Ex : jeanmarc@gmail.com',
    raison_sociale_placeholder: 'Ex : Commune des Lilas',
    isAncien: 'Site existant depuis plus de  2 ans',
    first_power: 'Énergie de chauffage principale',
    electricity: 'Électricité',
    combustible: 'Combustible',
    no_pertinence: 'Non pertinent',
    alert:
      'Dans le cas où le site n’est ni un site ou tertiaire, sélectionner “ Non-pertinent ”',
    alert_2:
      'Si vous n’avez pas d’ordre d’idée de la date d’engagement prévisionnelle, indiquer une date correspondant à la date actuelle + 15 jours',
    surface: 'Surface totale chauffée de la partie réhabilitée',
    dateDebutTravaux: 'Date prévisionnelle de début des travaux',
    start_work_after_end_work:
      'Doit être antérieure à la date de fin prévisionnelle des travaux',
    dateFinTravaux: 'Date prévisionnelle de fin des travaux',
    end_work_before_start_work: 'Doit être postérieure à la date d’engagement',
    interlocuteurChantierLastname: 'Nom de l’interlocuteur chantier',
    interlocuteurChantierFirstname: 'Prénom de l’interlocuteur chantier',
    interlocuteurChantierEmail: 'Email de l’interlocuteur chantier',
    raisonSocialeBeneficiaire: 'Raison sociale du bénéficiaire',
    nomSite: 'Nom du site',
    adresseSite: 'Adresse',
    codePostalSite: 'Code postal',
    villeSite: 'Ville',
    nomSite_placeholder: 'Ex : École des Petits Champs',
    adresseSite_placeholder: 'Ex : 189 boulevard des Petits Champs',
    codePostalSite_placeholder: 'Ex : 93300',
    villeSite_placeholder: 'Ex : Sarcelles',
  },
  add_dossier_project: {
    isAncien: 'Bâtiment existant depuis plus de 2 ans',
    nature: 'Nature des travaux',
    usage: 'Usage du site',
    operation: 'Type d’opération',
    surfaceVentileeRehabilitee:
      'Surface totale ventilée de la partie réhabilitée (m²)',
    ancienneEnergieChauffage: 'Ancienne énergie de chauffage du bâtiment',
    nouvelleEnergieChauffage: 'Nouvelle énergie de chauffage du bâtiment',
    surfaceChauffee: 'Surface totale chauffée du bâtiment (m²)',
    surfaceChauffeeRehabilitee:
      'Surface totale chauffée de la partie réhabilitée (m²)',
  },
  add_dossier_beneficiary: {
    same_contact:
      'Le contact du bénéficiaire est-il le même que l’interlocuteur pour le suivi des dossiers ?',
    civilite: 'Civilité',
    lastname: 'Nom du contact bénéficiaire',
    lastname_placeholder: 'Ex : Dupont',
    firstname: 'Prénom du contact bénéficiaire',
    firstname_placeholder: 'Ex : Jean',
    email: 'Adresse e-mail du contact bénéficiaire',
    email_placeholder: 'Ex : jean.dupont@exemple.com',
    telephone: 'Téléphone du contact bénéficiaire',
    telephone_placeholder: 'Ex : 06 12 34 56 78',
    descriptionProjet: 'Décrivez-nous votre projet :',
    descriptionProjet_placeholder:
      'Décrivez-nous votre projet, afin que nous puissions vous accompagner au mieux dans vos démarches d’efficacité énergétique',
    files: 'Déposez vos fichiers ici',
    files_title: 'Ajoutez vos documents',
    files_browse: 'Parcourir…',
    files_max_size: 'Taille maximale : {{size}} Mo',
    files_description:
      "Vous pouvez ajouter jusqu'à 10 fichiers simultanément.\nSi vous voulez ajouter plus de 10 fichiers, effectuez le dépôt en plusieurs fois.",
  },
  dossiers: {
    hero: 'Suivi des dossiers ({{count}})',
    filter: 'Filtres',
    referent: 'Interlocuteur chantier',
    keyword: 'Rechercher par référence chantier, adresse des travaux, FOST…',
    keyword_concessionnaire:
      'Rechercher par référence dossier, adresse des travaux, FOST…',
    filter_statuts: 'Filtrer par statuts',
    filter_referent: 'Filtrer par interlocuteur chantier',
    export: 'Exporter au format Excel',
    reset: 'Réinitialisation',
    filter_modal_title: 'Filtres',
    reset_filters: 'Réinitialiser',
    apply_filters: 'Appliquer',
    by_worksite_status: 'Par statut du chantier',
    by_multi_marque: 'Par marque de véhicule',
    select_multi_marque: 'Sélectionner une marque de véhicule',
    multi_marque_error:
      'Impossible de récupérer les marques de véhicules actuellement.',
    by_company_etx: 'Par entreprise de travaux',
    select_company: 'Sélectionner une entreprise',
    company_etx_error:
      'Impossible de récupérer les entreprises de travaux actuellement.',
    by_company_mobility_elec: 'Par concession',
    select_company_mobility_elec: 'Sélectionner une concession',
    company_mobility_elec_error:
      'Impossible de récupérer les concessions actuellement.',
    select_all_deselect: 'Tout sélectionner / Désélectionner',
    by_chantier: 'Par date de fin de chantier',
    by_chantier_concessionnaire: 'Par date de livraison',
    date_range_select: 'Sélectionnez une date ou une période',
    date_range_start: 'À partir de',
    date_range_end: 'Jusqu’au',
    board_version: 'Vue tableau',
    graph_version: 'Vue graphique',
    no_address: 'Adresse non renseignée',
    operations_en_cours: '{{count}} opérations en cours',
    operations_en_cours_one: '{{count}} opération en cours',
    updated_at: 'Mis à jour le {{date}}',
    voir_details_carte: 'Voir le détail de la carte',
    select_account: 'Sélectionnez un compte',
    filter_by_account: 'Par compte',
  },
  dossier_table: {
    no_data: 'Aucune donnée disponible',
    beneficiaire_raisonSociale: 'Raison sociale du bénéficiaire',
    beneficiaire: 'Beneficiaire',
    site_nom: 'Nom du site',
    concession_nom: 'Nom de l’établissement du bénéficiaire',
    site_adresse: 'Adresse des travaux',
    concession_adresse: 'Adresse de l’établissement du bénéficiaire',
    dateModification: 'Date de mise à jour',
    chantier_dateFinTravaux: 'Fin de chantier',
    concession_dateFinTravaux: 'Date de livraison',
    chantier_reference: 'Réf. chantier',
    concession_reference: 'Référence',
    chantier_numeroDevis: 'N° du bon de commande',
    chantier_montant: 'Montant des primes',
    chantier_montant_tooltip: 'Montant de prime versée au bénéficiaire',
    statut: 'Statut',
    referentCommercial: 'Interlocuteur chantier',
    operation_libelle: 'Opérations',
    operation_fost: 'Fiches d’opérations standardisées',
    operation_montantPrime: 'Montant prime d’opération',
    last_updated: 'Mis à jour le',
    details: 'Voir détail',
    user: 'Raison sociale de l’installateur',
    aucune_operation: 'Il n’existe aucune opération pour ce dossier.',
    open_street_view: 'Ouvrir dans Google Street View',
    no_street_view_url: 'Aucune URL Street View disponible',
    thumbnail_alt: 'Vue Street View',
    no_thumbnail_alt: 'Aucune miniature Street View disponible',
  },
  faq: {
    title: 'FAQ',
    hero_0: 'Foire aux',
    hero_1: 'questions',
  },
  mon_compte: {
    hero: 'Mon compte',
    subtitle: 'Mes informations personnelles',
    lastname: 'Nom',
    firstname: 'Prénom',
    phone: 'Téléphone',
    email: 'Email',
    entreprise: 'Entreprise',
    siret: 'SIRET',
    adresse: 'Adresse de l’établissement',
    deconnexion: 'Se déconnecter',
    mentions: 'Mentions légales',
    politique: 'Politique de confidentialité',
    conditions: 'CGU',
  },
  calculer_une_prime: {
    hero: 'Calculer une prime',
    subtitle:
      'Calculez la prime CEE Hellio associée à votre opération en quelques clics.',
    tab: {
      calculateur: {
        label: 'Simulateur de prime',
      },
      historique: {
        label: 'Historique des simulations',
        export: 'Exporter mes simulations au format Excel',
        table: {
          date: 'Date',
          name: 'Nom de la simulation',
          fost: {
            value: 'Type de site',
            label: 'Libellé de l’opération',
          },
          repartitionPrime: 'Répartition Bénéficiaire / Professionnel',
          volume: 'Volume CEE',
          prime: 'Montant de prime total',
          montantPrimeBenef: 'Répartition Prime Bénéficiaire',
          montantPrimePro: 'Répartition Prime Professionnel',
        },
      },
    },
    description:
      'Calculez la prime CEE Hellio associée à votre opération ' +
      'en quelques clics.',
    error_get_data: 'Impossible de récupérer les informations pour le moment :',
    error_simulation: 'Impossible d’exécuter la simulation :',
    secteur: 'Secteur',
    date: 'Date',
    numero_fost: 'Type d’opération (FOST)',
    ville: 'Ville',
    type_de_site: 'Type de site',
    champs_requis: {
      codePostalVille: 'Code postal',
      code_postal_ville_please_select: 'Sélectionnez un code postal.',
      departement: 'Département',
      departement_please_select: 'Sélectionnez un département.',
      departement_search: 'Numéro ou nom du département…',
      departement_zc: 'Département (ZC)',
      zone_climatique: 'Zone climatique',
      code_postal_ville_search: 'Recherchez par code postal ou par ville…',
      generic_please_select: 'Veuillez saisir le champ {{name}}.',
      generic_placeholder: 'Saisissez {{name}}…',
    },
    operation: 'Sélectionnez l’opération correspondant à votre demande',
    operation_placeholder: 'Choisissez parmi la liste…',
    operation_please_select: 'Veuillez sélectionner une opération.',
    operation_date: 'Date prévisionnelle de l’opération',
    operation_date_please_select: 'Veuillez sélectionner une date.',
    entrez_code_postal: 'Entrez un code postal',
    batiment: {
      question: 'De quel type de site s’agit-il ?',
      please_select: 'Veuillez sélectionner un secteur.',
      agricole: 'Bâtiment agricole',
      industriel: 'Bâtiment industriel',
      tertiaire: 'Bâtiment tertiaire',
      residentiel: 'Bâtiment résidentiel',
      reseaux: 'Réseaux',
    },
    criteres_eligibilite: 'Critères d’éligibilité',
    voir_criteres_eligibilite: 'Voir les critères d’éligibilité',
    calculer_ma_prime: 'Calculer ma prime ',
    calculer_une_prime: 'Calculer une prime',
    resultat: {
      calcul_de_la_prime: 'Calcul de la prime',
      votre_situation: 'Votre situation',
      votre_resultat_simulation: 'Votre résultat de simulation',
      votre_simulation: 'Votre simulation',
      reinitialiser: 'Réinitialiser',
      recommencer: 'Recommencer',
      code_postal: 'Code postal',
      montant_de_la_prime: 'Montant de la prime',
      montant_de_la_prime_description:
        'Le montant de prime estimé indiqué ici est calculé sur la base des paramètres que vous avez indiqué dans le calcul, valable au jour du calcul. Ce montant est conditionné au respect des critères d’éligibilité CEE et est susceptible d’évoluer en fonction des travaux effectivement réalisés, de la date effective d’engagement des travaux, des éventuelles évolutions réglementaires, et de l’évolution des paramètres de chantier déclarés à ce stade.',
      volume_de_CEE_reel: 'Volume de CEE réel',
      prime_globale: 'Prime globale',
      prime_pro: 'Prime professionnel',
      prime_beneficiaire: 'Prime Bénéficiaire',
      prime_professionnel: 'Prime Professionnel',
      repartition_beneficiaire_pro: 'Répartition entre le Professionnel et le Bénéficiaire',
      repartition_summary:
        'Je reverse {{pourcentage}} de la prime au Bénéficiaire.',
      montant_max_prime:
        'Le montant maximum de la Prime Professionnel ne peut dépasser {{max}} %.',
      prime_professionnel_max_error:
        'La prime professionnel ne peut pas dépasser 20%',
      montant_prime_rappel_warning:
        'Nous vous rappelons de faire valider' +
        ' votre devis' +
        ' avec remise par nos équipes spécialisées avant de le faire signer à vos clients.',
      enregistrer_ma_simulation: 'Enregistrer la simulation',
      precedent: 'Précédent',
      soumettre_un_dossier: 'Soumettre un dossier',
      enregistrer_une_simulation: 'Sauvegarder une simulation',
      nom_de_la_simulation: 'Nom de la simulation',
      veuillez_nommer_simulation: 'Nommer la simulation',
      nom_obligatoire: 'Le nom de la simulation est obligatoire',
      nom_placeholder: 'Saisir un nom',
      valider: 'Valider',
      confirmation_enregistrement: {
        sauvegarde_de_simulation: 'Sauvegarde de la simulation',
        simulation_bien_enregistree: 'Votre simulation a bien été enregistrée',
        simulation_bien_enregistree_description:
          'Vous pouvez retrouver votre simulation dans l’onglet “Historique des simulations”.',
        simulation_probleme_enregistrement:
          'Un problème est survenu lors de l’enregistrement de votre simulation',
        acceder_historique_simulation: 'Accéder à l’historique',
      },
      error: {
        montant_prime_non_calculable:
          'Le montant de la prime n’est pas calculable en l’état.',
        information_interlocuteur:
          'Pour ce chiffrage spécifique, merci de contacter votre référent Hellio.',
      },
      revenir_a_la_calculette: 'Revenir à l’accueil',
    },
  },
  dashboard: {
    hero: 'Tableau de bord',
    hero_print: 'Hellio_Tableau_de_bord_{{date}}',
    export_print: 'Imprimer',
    en_pourcentage: 'En pourcentage',
    dossiers: {
      title: 'Dossiers en cours selon leur statut',
      vue_operations: 'Par opérations',
      vue_chantiers: 'Par chantiers',
      etudes_en_cours: 'Études en cours',
      offres_emises: 'Offres émises',
      offres_acceptees: 'Offres acceptées',
      chantiers_en_cours: 'Chantiers en cours',
      documents_en_attente: 'Documents en attente',
      dossiers_en_cours: 'Dossiers en cours de validation',
      en_attente_bureau: 'En attente de passage Bureau de contrôle',
      dossiers_incomplets: 'Dossiers incomplets',
      dossiers_valides: 'Dossiers validés',
      dossiers_prime_versee: 'Prime versée',
    },
    operationSecteur: {
      title: 'Répartition des opérations par secteur',
      data_not_available:
        'Ce graphique s’affichera dès que des données seront disponibles',
    },
    volumetrie: {
      label: 'Volumétrie CEE générée',
      mwhc: 'MWh cumac',
    },
    chantiers: {
      title_client_users:
        'Chantiers selon la date prévisionnelle de fin de travaux',
      title_simulateur_users: 'Primes prévisionnelles',
      hint_simulateur_users: 'En MWhc',
      chantiers_mois: 'Chantiers par mois',
      chantiers_trimestre: 'Chantiers par trimestre',
      primes_mois: 'Primes par mois',
      primes_trimestre: 'Primes par trimestre',
      vue_chantier: 'Par chantier',
      vue_prime: 'Par prime',
    },
    montants_primes: {
      title: 'Montant des primes validées',
      validee: 'Total',
      annee_en_cours: "Sur l'année en cours",
      annee_precedente: "Sur l'année précédente",
    },
    montants_primes_chantiers: {
      title: 'Primes cumulées',
      chantiers_termines: 'Chantiers terminés',
      chantiers_en_cours: 'Chantiers en cours',
      chantiers_en_attente: 'Chantiers en attente d’informations',
      prime_beneficiaire: 'Prime bénéficiaire',
      prime_professionnel: 'Prime professionnel',
    },
    top_operations: {
      title: 'Opérations les plus valorisées',
      data_not_available:
        'Ce graphique s’affichera dès que des données seront disponibles',
    },
    conversion_dossiers: {
      title: 'Taux de conversion',
      subtitle: 'En pourcentage',
      accepte: 'Gagnés',
      refuse: 'Perdus',
      en_cours: 'En attente de retour',
    },
  },
  cta_calculer_prime: {
    title: 'Un nouveau projet ?',
    description: 'Calculez votre prime en quelques clics.',
    label: 'Calculer une prime',
  },
  dossier: {
    etapes: 'Étapes de votre dossier',
    back_to_dossiers: 'Retour aux dossiers',
    hero: 'Vue détaillée du dossier',
    history_title: 'Historique des statuts',
    reference_chantier: 'Référence chantier',
    reference_cotation: 'Référence cotation Hellio',
    reference_dossier: 'Référence du dossier',
    statut_dossier: 'Statut du dossier',
    interlocuteur_chantier: 'Interlocuteur chantier',
    interlocuteur_concession: 'Interlocuteur concessionnaire',
    infos_chantier: 'Informations concernant le chantier',
    voir_plus: 'Voir plus',
    voir_details: 'Voir détails',
    infos_benef_chantier: 'Informations bénéficiaire et chantier',
    infos_benef_concession: 'Informations bénéficiaire et dossier',
    coordonnees_beneficiaire: 'Coordonnées du bénéficiaire',
    raison_sociale: 'Raison sociale',
    siren: 'Numéro de SIREN',
    adresse_siege: 'Adresse du siège',
    nom_beneficiaire: 'Nom du bénéficiaire',
    prenom_beneficiaire: 'Prénom du bénéficiaire',
    beneficiaire: 'Bénéficiaire',
    contact: 'Contact',
    email_beneficiaire: 'Email du bénéficiaire',
    telephone_beneficiaire: 'Téléphone du bénéficiaire',
    chantier: 'Chantier',
    concession: 'Dossier de prime',
    nom_site: 'Nom du site',
    adresse_chantier: 'Adresse du chantier',
    adresse_chantier_concession: 'Adresse du client bénéficiaire',
    raison_sociale_installateur: 'Raison sociale de l’installateur',
    raison_sociale_installateur_concession: 'Raison sociale du concessionnaire',
    siret_installateur: 'SIRET de l’installateur',
    montant_total_prime_chantier: 'Montant total des primes du chantier',
    montant_total_prime_concession: 'Montant total des primes',
    date_engagement_chantier: 'Date d’engagement avec Hellio',
    date_creation: 'Date de création',
    modele_incitation: 'Choix du modèle d’incitation financière',
    operations: 'Opérations',
    operations_en_cours: 'Opérations en cours ({{count}})',
    documents: 'Documents ({{count}})',
    ajout_document: 'Ajouter un document',
    ajout_mes_documents: 'Ajouter mes documents',
    document_upload_success_one: 'Le document a été ajouté avec succès.',
    document_upload_success:
      '{{count}} documents relatifs à votre chantier ont été ajoutés.',
    documents_one: 'Document ({{count}})',
    document_name: 'Nom du document',
    document_category: 'Catégorie de document',
    document_characteristics: 'Caractéristique du document',
    search_documents_placeholder:
      'Rechercher par nom de document, catégorie du document',
    filters: 'Filtres',
    reset_filters: 'Réinitialiser',
    apply_filters: 'Appliquer',
    by_document_type: 'Par type de document',
    select_all_deselect: 'Tout sélectionner / Tout désélectionner',
    sort_by_recent: 'Trier par : Les plus récents',
    sort_by_oldest: 'Trier par : Les plus anciens',
    sort_name_a_to_z: 'Trier par nom : A à Z',
    sort_name_z_to_a: 'Trier par nom : Z à A',
    upload_documents_description: 'Déposer un ou plusieurs document(s)',
    upload_file_info:
      'Taille maximale : {{max}}. Formats supportés : {{formats}}. 1 fichier max.',
    no_document_selected: 'Aucun document sélectionné',
    document_type_selection_title:
      'Sélectionnez une catégorie de document pour chaque fichier <0>(facultatif)</0>',
    document_type_selection_description: 'Déposer un ou plusieurs document(s)',
    uploaded_files_count: '{{count}} documents chargés',
    uploaded_files_count_one: '{{count}} document chargé',
    document_type_label: 'Type de document',
    document_type_placeholder: 'Sélectionner un type de document',
    add_more_files: "Ajouter d'autres fichiers",
    document_types: {
      accord_incitation: 'Accord d’Incitation Financière',
      preuve_engagement: "Preuve d'engagement",
      preuve_realisation: 'Preuve de réalisation',
      attestation_honneur: "Attestation sur l'Honneur",
      documents_justificatifs: 'Documents justificatifs spécifiques',
      autres: 'Autres',
    },
    suivi_du_dossier: 'Suivi du dossier',
    etapes_de_votre_dossier: 'Étapes de votre dossier',
    montant_total: 'Montant total',
    messagerie: 'Messagerie',
    info_operations: 'Informations concernant les opérations',
    libelle_operation: 'Libellé de l’opération',
    fiche_operation_standardisee: 'Fiche d’opération standardisée',
    fost: 'FOST',
    criteres_eligibilite: 'Critères d’éligibilité',
    reglementaire: 'Réglementaire',
    mentions_facture: 'Mentions à faire figurer sur le devis / facture',
    points_vigilance: 'Points de vigilance',
    montant_prime_operation: 'Montant prime d’opération',
    pieces_dossier: 'Pièces du dossier',
    statut: 'Statut',
    ahManagement: 'Gestion de l’AH',
    info_ah_button: {
      aria_label: 'Afficher les informations',
      title: 'Générez puis déposez l’attestation sur l’Honneur ici',
    },
    interlocuteur_chantier_indefini: 'Indéfini',
    dossier_refuse: 'Le dossier a été refusé',
    dossier_abandonne: 'Le dossier a été abandonné',
    dossier_incomplet: 'Le dossier est incomplet',
    paiement: {
      dossier_comptable: 'Demande comptable à émettre par Hellio',
      releve_prime_effectuee: 'Document en attente pour paiement',
      facture_recue: 'Paiement en cours de traitement',
    },
    documents_attaches_one: "Document lié à l'opération",
    documents_attaches: "Documents liés à l'opération",
    concessionnaire: {
      formulaire2: {
        title: 'Formulaire',
        button: 'Validation d’achat et génération d’AH',
        regenerer: 'Regénération de l’AH',
        fields: {
          reference: {
            label: 'Référence de la facture ou du contrat de location',
            placeholder: 'Ex : FACT-202504-25',
          },
          date: {
            label: 'Date de facture ou du contrat de location',
            placeholder: 'Sélectionnez une date',
          },
          bon_commande: {
            label: 'Bon de commande',
            placeholder: 'Glissez le bon de commande signé',
          },
          invoice_upload: {
            label: 'Facture ou contrat de location',
            placeholder: 'Glissez la facture ou le contrat de location',
          },
          other_documents: {
            label: 'Autres documents',
            info: 'Pour les véhicules précédemment affectés à la démonstration, le premier certificat d’immatriculation ainsi que le second, et le récépissé de fin de démonstration doivent être fournis.',
            placeholder: 'Glissez le document ou cliquez ici pour le charger',
          },
          registration: {
            label: 'N° d’immatriculation du véhicule',
            placeholder: 'Ex : AA-000-AA',
          },
          identification: {
            label: 'N° d’identification',
            placeholder: 'Ex : JH4DA1750JS009856',
          },
          certificat: {
            label: 'Certificat provisoire ou définitif d’immatriculation',
            placeholder:
              'Glissez le certificat d’immatriculation ou cliquez ici pour le charger',
          },
          type_variante_version: {
            label: 'Type variante version',
            placeholder: 'Ex : SV63C6620023336M3',
            tip: "Se référer à la section D2 du certificat d'immatriculation",
          },
          attestation_de_transformation: {
            label:
              "Pour les véhicules issus d'une opération de rétrofit : l'attestation de transformation",
            placeholder:
              'Glissez l’attestation de transformation ou cliquez ici pour le charger',
          },
          premier_certificat_immatriculation: {
            label:
              "Pour les véhicules précédemment affectés à la démonstration : le premier certificat d'immatriculation",
            placeholder:
              'Glissez le premier certificat d’immatriculation ou cliquez ici pour le charger',
          },
          recepisse_fin_demonstration: {
            label:
              'Pour les véhicules précédemment affectés à la démonstration : le récépissé de fin de démonstration',
            placeholder:
              'Glissez le récence de fin de démonstration ou cliquez ici pour le charger',
          },
          coordinates: {
            title: 'Coordonnées du client signataire',
            info: 'Veuillez vérifier que le signataire est correct ou le modifier si besoin',
          },
          lastname: {
            label: 'Nom',
            placeholder: 'Bertrand',
          },
          firstname: {
            label: 'Prénom',
            placeholder: 'Noé',
          },
          phone: {
            label: 'Téléphone',
            placeholder: '08 77 66 33 88',
          },
          email: {
            label: 'Email',
            placeholder: 'noe.bertrand@email.fr',
          },
          submit_button: {
            label: 'Valider',
          },
        },
        success:
          'L’Attestation sur l’Honneur liée à l’opération {{fost}} a bien été générée.',
      },
      ah: {
        title: 'Attestation sur l’Honneur',
        fileName: 'Document PDF de l’Attestation sur l’Honneur',
      },
      pieces: {
        title: 'Pièces de l’opération',
        button: 'Déposer des fichiers',
        no_operations: 'Aucune opération pour ce dossier',
      },
    },
  },
  info_bulles: {
    status: {
      vue_operations:
        'Comptage du nombre de dossiers concernés, opération par opération',
      vue_chantiers: 'Comptage du nombre de chantiers au statut concerné',
    },
    montant_total_primes_validee:
      'Somme des primes validées depuis le début du partenariat avec Hellio',
    montant_prime_validee_annee_en_cours:
      'Somme des primes validées sur l’année calendaire',
    montant_prime_validee_annee_en_precedente:
      'Somme des primes validées sur l’année calendaire précédente',
    operation_plus_valorisee:
      'Top 5 des opérations pour lesquelles des CEE ont été validés',
    chantier_selon_date_previsionnelle:
      'Vision des chantiers à venir ou en cours selon la date de fin de travaux communiquée',
    volumetrie_cee_generee: 'Volumétrie CEE générée',
    repartition_operation_secteur:
      'Dossiers validés, répartis en fonction du secteur : Tertiaire, Industrie, Agriculture, Réseaux, Transport',
  },
  indicateurs: {
    vue_operation: {
      indicateur: 'Dossiers en cours selon leur statut - Vue par opérations',
      definition:
        'Comptage du nombre de dossiers concernés, opération par opération',
    },
    vue_chantiers: {
      indicateur: 'Dossiers en cours selon leur statut - Vue par chantiers',
      definition: 'Comptage du nombre de chantiers au statut concerné',
    },
    montant_total_primes_validee: {
      indicateur: 'Montant total des primes validées',
      definition:
        'Somme des primes validées depuis le début du partenariat avec Hellio',
    },
    montant_prime_validee_annee_en_cours: {
      indicateur: 'Montant des primes validées sur l’année en cours',
      definition: 'Somme des primes validées sur l’année calendaire',
    },
    montant_prime_validee_annee_en_precedente: {
      indicateur: 'Montant des primes validées sur l’année précédente',
      definition: 'Somme des primes validées sur l’année calendaire précédente',
    },
    operation_plus_valorisee: {
      indicateur: 'Opérations les plus valorisées',
      definition:
        'Top 5 des opérations pour lesquelles des CEE ont été validés',
    },
    chantier_selon_date_previsionnelle: {
      indicateur: 'Chantiers selon la date prévisionnelle de fin de travaux',
      definition:
        'Vision des chantiers à venir ou en cours selon la date de fin de travaux communiquée',
    },
    volumetrie_cee_generee: {
      title: 'Volume annuel',
      hint: 'En MWhc',
      indicateur: 'Volumétrie CEE générée',
      definition: 'Total des CEE générés sur les dossiers validés',
    },
    repartition_operation_secteur: {
      indicateur: 'Répartition des opérations par secteur',
      definition:
        'Dossiers validés, répartis en fonction du secteur : Tertiaire, Industrie, Agriculture, Réseaux, Transport',
    },
  },
  statuts_dossiers_definitions: {
    EtudeEnCours:
      'Dossier en phase d’étude par Hellio, afin de fournir un chiffrage des primes CEE, et des préconisations',
    OffreEmise:
      'Retour chiffré effectué par Hellio, en attente de la signature de l’Accord Incitation Financière (AIF)',
    OffreAcceptee:
      'Le RAI est signé, la preuve d’engagement des opérations peut donc être signée',
    ChantierEnCours:
      'L’Accord d’Incitation Financière a été signé, le chantier peut démarrer ou est en cours',
    ChantierEnCours_concession:
      'L’Accord d’Incitation Financière a été signé, le dossier peut démarrer ou est en cours',
    DocumentsEnAttente:
      'Dossier en attente de documents (l’Attestation sur l’Honneur de fin des travaux par exemple) pour pouvoir être vérifié et validé',
    DocumentsEnAttente_concession:
      'Dossier en attente de documents (l’Attestation sur l’Honneur de livraison par exemple) pour pouvoir être vérifié et validé',
    EnCoursDeValidation: 'Dossier en cours de vérification par nos équipes',
    EnAttenteDeControle:
      'Dans le cadre du dispositif CEE, l’opération doit être contrôlée par un organisme indépendant, sur site ou par contact, avant de passer à l’étape suivante',
    Valide:
      'Dossier complet et validé par nos équipes, donnant lieu à une prime CEE',
    Valide_sous_statuts: {
      DemandeComptable:
        "Une demande de documents comptables (note de débours ou facture, RIB) est à émettre par le service Facturation d'Hellio.",
      DocumentAttentePaiement:
        "Le service Facturation d'Hellio est en attente des documents comptables demandés pour permettre le paiement.",
      PaiementEnCours:
        'Les documents comptables ont été reçus, et le paiement est en cours de traitement.',
    },
    Termine:
      'Dossier complet, donnant lieu à une prime CEE pour les opérations validées',
    PrimeVersee:
      'Dossier complet pour lequel l’ensemble de la prime CEE a été versée',
    Incomplet:
      'Pièce(s) du dossier manquante(s) ou non conforme(s) ; des éléments sont à compléter ou corriger',
    Refuse:
      'Dossier refusé, suite à un souci d’éligibilité, un retard dans le dépôt du dossier…',
    Abandon:
      'Dossier abandonné, suite à un changement d’opération(s), un report du chantier…',
    Abandon_concession:
      'Dossier abandonné, suite à un changement d’opération(s), un report de la livraison…',
  },
  statuts_operations_definitions: {
    Eligible:
      'Le dossier remplit les conditions requises pour bénéficier de la prime CEE.',
    AConfirmer:
      'Des éléments du dossier doivent encore être vérifiés par nos équipes pour confirmer l’éligibilité.',
    NonConfirme:
      'Le dossier présente des manques empêchant de statuer pour l’instant sur l’éligibilité aux CEE.',
    Recommandations:
      'Des ajustements ou des préconisations sont proposés (sur le plan technique ou administratif) pour rendre l’opération éligible.',
    Annule:
      'Le dossier a été annulé par le client ou par nos équipes, avant ou pendant le traitement.',
    DossierEnCoursDeValidation:
      'Dossier en cours de vérification par nos équipes.',
    Incomplet:
      'Pièce(s) du dossier manquante(s) ou non conforme(s) ; des éléments sont à compléter ou corriger.',
    RemisAuControle:
      'Dans le cadre du dispositif CEE, l’opération doit être contrôlée par notre pôle qualité en interne, sur site ou par contact, avant de passer à l’étape suivante.',
    PreValide:
      'Dossier complet et validé par nos équipes, en attente du passage du bureau de contrôle.',
    BonPourPrime:
      'Dossier complet et validé par nos équipes, donnant lieu à une prime CEE.',
    NonConforme:
      'Le dossier présente des non-conformités liées à la qualité des travaux ou des documents, le rendant inéligible en l’état.',
    ActionEnCours:
      'Une action est en cours de la part de nos équipes ou de votre côté pour faire avancer le traitement du dossier (Audit téléphonique, validation RGE…).',
    Litige:
      'Le dossier est bloqué suite à un différend (manque d’information sur l’AH, document illisible…) nécessitant un arbitrage ou une résolution.',
    Refuse:
      'Dossier refusé, suite à un souci d’éligibilité, un retard dans le dépôt du dossier…',
    Retire: 'Dossier retiré.',
  },
  glossaire: {
    title: 'Glossaire',
    ressources: 'Ressources',
    definition: 'Définition',
    section_title_dossier_status:
      'Définition des statuts du dossier / chantier',
    section_title_dossier_status_concession:
      'Définition des statuts du dossier',
    section_title_operation_status: 'Définition des statuts de l’opération',
    title_statuts_dossier: 'Statut du dossier / du chantier',
    title_statuts_operation: 'Statut de l’opération',
    modal_title_dossiers_statuts_definition: 'Statut du dossier / du chantier',
    modal_title_operations_statuts_definition: 'Statut du dossier',
  },
  news: {
    title: 'Actualités',
    read: 'Lire l’article',
    loading: 'En cours de chargement. Veuillez patienter…',
    error:
      'Une erreur c’est produite lors du chargement des articles. Veuillez réessayer plus tard!',
  },
  contact: {
    title: 'Votre référent Hellio',
    no_contact: 'Aucun référent commercial n’est rattaché à votre compte.',
  },
  notification: {
    title: 'Notifications',
    no_notification: 'Vous n’avez actuellement aucune notification.',
    mark_as_read: 'Tout marquer comme lu',
    message: {
      DossierEnCoursDeValidation:
        'Le chantier {{dossier.chantier.reference}} – {{dossier.beneficiaire.raisonSociale}} est en cours de validation.',
      DossierValide:
        'Le chantier {{dossier.chantier.reference}} – {{dossier.beneficiaire.raisonSociale}} est passé en "Bon pour Prime".',
      ChantierEnAttenteDeControle:
        'Le chantier {{dossier.chantier.reference}} – {{dossier.beneficiaire.raisonSociale}} est passé en "En attente de contrôle".',
      FinChantierJMoins30:
        'La date prévisionnelle du chantier {{dossier.chantier.reference}} – {{dossier.beneficiaire.raisonSociale}} est proche, merci d’envoyer les dernières pièces du dossier CEE.',
      FinChantierJPlus45:
        'La date prévisionnelle du chantier {{dossier.chantier.reference}} – {{dossier.beneficiaire.raisonSociale}} est dépassée, merci d’envoyer les dernières pièces du dossier CEE.',
      FichierOperation:
        '{{dossier.proprietaire.firstname}} {{dossier.proprietaire.lastname}} a déposé une pièce jointe sur le chantier {{dossier.chantier.reference}} – {{dossier.beneficiaire.raisonSociale}}.',
    },
  },
  attachments: {
    parcourir: 'Parcourir…',
    ajouter_fichier: 'Ajouter un fichier',
    aucun_document: 'Aucun document sélectionné',
    deposez_fichiers: 'ou déposez vos fichiers ici',
    error_type: 'Le type de fichier {{type}} n’est pas autorisé.',
    error_size: 'La taille des fichiers est limitée à {{size}} Mo.',
    file_size_error:
      "Le fichier {{filename}} n'a pas pu être importé correctement (> {{maxSize}} Mo).",
    download_error: 'Erreur de téléchargement',
    download_error_description:
      'Le fichier {{file}} n’a pas pu être téléchargé :',
    upload_error: 'Erreur de chargement',
    upload_error_description: 'Le fichier {{file}} n’a pas pu être ajouté :',
  },
  documents: {
    no_document: 'Aucun document.',
    preview_document: 'Prévisualiser le document',
    download_document: 'Télécharger le document',
  },
  upload: {
    glissez: 'Glissez vos documents ou <0>cliquez ici pour les charger</0>',
  },
  primes_table: {
    title: 'Tableau des primes',
    sub_title:
      'Achat d’un véhicule léger électrique, utilitaire ou particulier',
    car: 'Véhicule léger',
    utility: 'Utilitaire léger',
    select_marque_placeholder: 'Sélectionnez la marque des véhicules',
    info_alert: {
      title_entreprise: 'Pour les entreprises, ',
      title_collectivite: 'Pour les collectivités, ',
      description_entreprise:
        'la taille de la flotte à prendre en compte est celle du groupe, intégrant tout type de véhicule dont le poids total autorisé en charge est < 3,5 tonnes (équivalent M1 ou N1) : location longue durée, leasing, propriété…',
      description_collectivite:
        'la taille de la flotte à prendre en compte intègre tout type de véhicule dont le poids total autorisé en charge est < 3,5 tonnes (équivalent M1 ou N1) : location longue durée, leasing, propriété…',
    },
    company_less_100: 'Société < 100 véhicules',
    company_more_100: 'Société > 100 véhicules',
    org_less_20: 'Collectivité < 20 véhicules',
    org_more_20: 'Collectivité > 20 véhicules',
    less_100: '< 100 véhicules',
    more_100: '> 100 véhicules',
    less_20: '< 20 véhicules',
    more_20: '> 20 véhicules',
    company: 'Entreprise privée',
    org: 'Collectivité locale',
    company_type: 'Type d’entreprise',
    size: 'Taille du parc',
    prime_per_vehicle: 'Prime par véhicule',
    prime_per_gwh: 'Prime par GWh cumac (€)',
    no_active_contract:
      "Aucun contrat actif n'est associé à votre structure. Merci de contacter votre interlocuteur Hellio.",
  },
  precarite_info: {
    title_personnes: 'Nombre de personnes composant le ménage',
    title_revenus: 'Plafonds de revenus du ménage (€)',
    precaire: 'Précaire',
    modeste: 'Modeste',
    personne_supplementaire: 'Par personne supplémentaire',
  },
  home: {
    welcome: 'Accueil',
    total_validated_premiums: 'Total des primes validées',
    generated_cee_volume: 'Volumétrie CEE générée',
    cee_volume_tooltip: 'Total des CEE générés sur les dossiers validés',
    total_validated_dossiers: 'Total de dossiers validés',
    see_graph_view: 'Voir vue graphique',
    recent_activities: 'Dernières activités de dossiers',
    follow_dossiers: 'Suivre mes dossiers',
    alerts: 'Alertes',
    see_all_notifications: 'Voir toutes les notifications',
    latest_news: 'Dernières actualités',
    read_articles: 'Lire les articles',
    window_alt: 'Fenêtre illustration',
    regulatory_calendar: 'Calendrier réglementaire',
    recent_publications: 'Publications récentes au journal officiel',
    access_calendar: 'Accéder au calendrier',
  },
  menu: {
    home: 'Accueil',
    dossiers: 'Mes dossiers',
    ressources: 'Ressources',
    collapse: 'Réduire',
    expand: 'Développer',
    expand_sidebar: 'Développer la barre latérale',
    collapse_sidebar: 'Réduire la barre latérale',
  },
  resources: {
    page_title: 'Centre de Ressources',
    home_center: {
      title: 'Centre de ressources',
      cta: 'Accéder au centre de ressources',
    },
    header: {
      title: 'Que recherchez-vous ?',
    },
    search_placeholder: 'Rechercher un support…',
    categories: {
      all: 'Tous les supports',
      actus_reglementaire: 'Actus et réglementaire',
      accompagnement: 'Accompagnement de Hellio',
      fiches_renseignement: 'Fiches de renseignement',
      grilles_tarifaires: 'Grilles tarifaires',
      modes_emploi: "Modes d'emploi et process",
      presse: 'Presse',
      notes_decryptage: 'Notes de décryptage',
    },
    supports_count: 'Supports ({{count}})',
    see_more: 'Voir plus',
    see_all_news: 'Voir toutes les actualités',
    no_results: 'Aucun support trouvé',
    shortcuts: {
      calendar: {
        title: 'Calendrier réglementaire',
        description: 'Une vue d’ensemble des actualités réglementaires parues',
      },
      supports: {
        title: 'Supports',
        description:
          'Des notes de décryptage, infographies et guides pour vous accompagner au mieux',
      },
    },
    sections: {
      faq: 'Foire aux questions',
      faq_description: 'Les réponses aux questions les plus fréquentes',
      glossary: 'Glossaire',
      glossary_description: 'Le détail des métriques et statuts utilisés',
      latest_news: 'À la une',
      regulatory_news: 'Dernières actualités réglementaires',
      access_calendar: 'Accéder au calendrier',
    },
    filters: 'Filtres',
    breadcrumb: {
      home: 'Accueil',
      resources: 'Centre de Ressources',
      supports: 'Supports',
      search: 'Recherche',
    },
    search_results: 'Résultats de recherche ({{count}})',
    no_documents: 'Aucun support n’a été trouvé.',
    socials: 'Retrouvez-nous',
  },
};
